import { CapabilitiesStudioWidget } from '@/features/agents/components/capabilities-studio-widget';
import { Page } from '@/components/page';
import { HtmlPreviewWidget } from '@/features/agents/components/html-preview-widget';
import { useScreenId } from '@/hooks/use-screen-id';
import { useTabId } from '@/hooks/use-tab-id';
import { ContainerListWidget } from '@/features/containers/components/container-list-widget';
import { TreeStoreProvider } from '@/context/tree-context';
import { ExploreWidget } from '@/components/explore-widget';
import { CapabilitiesListWidget } from '@/features/capabilities/components/capabilities-list-widget';
import { AgentListWidget } from '@/features/agents/components/agent-list-widget';
import { SchemasListWidget } from '@/features/schemas/components/schemas-list-widget';
import { VaultListWidget } from '@/features/vault/components/vault-list-widget';
import { RunningAgentsListWidget } from '@/features/agents/components/running-agents-list-widget';

export function CapabilitiesStudio() {
  const tabId = useTabId();
  const screenId = useScreenId();
  const idPrefix = `${tabId}/${screenId}`;

  if (!tabId || !screenId) {
    return null;
  }

  return (
    <Page title="Capabilities Studio">
      <div className="grid gap-4">
        <VaultListWidget
          id={`${idPrefix}/vault-list`}
          hideable={true}
          defaultIsVisible={false}
        />
        <AgentListWidget id={`${idPrefix}/agent-list`} hideable={true} />
        <RunningAgentsListWidget id={`${idPrefix}/running-agents`} />
        <ContainerListWidget id={`${idPrefix}/list`} hideable={true} />
        <TreeStoreProvider name="custom-app">
          <ExploreWidget id={`${idPrefix}/explore`} hideable={true} />
        </TreeStoreProvider>
        <CapabilitiesListWidget
          id={`${idPrefix}/capabilities`}
          hideable={true}
        />
        <SchemasListWidget id={`${idPrefix}/schemas`} hideable={true} />
        <CapabilitiesStudioWidget id={`${idPrefix}/agent-studio`} />
        <HtmlPreviewWidget id={`${idPrefix}/html-preview`} />
      </div>
    </Page>
  );
}
